export function isPostRenderPlugin(plugin) {
    return !!plugin.postRender && typeof plugin.postRender === 'function';
}
//# sourceMappingURL=post-render.plugin.js.map